const CustomerModule = 'customer';
const RewardModule = 'reward';
const CampaignModule = 'campaign';
const PageHeaderModule = 'pageHeader';
const RuleModule = 'rule';
const GlobalModule = 'global';

export { CustomerModule, CampaignModule, PageHeaderModule, RewardModule, RuleModule, GlobalModule };
